import React from 'react';
import styles from './index.module.css';
import Title from 'components/Title';
import {useTranslation} from 'react-i18next';
import concatStyles from 'helpers/concatStyles';

interface Props {
  title?: string;
  requestClose?: Function;
  headerCustom?: () => React.ReactNode;
  headerRightClassName?: string;
  customWidth?: string;
  zIndex?: number;
}

const Modal: React.FC<Props> = ({
  title,
  requestClose,
  headerCustom,
  children,
  customWidth = '45%',
  zIndex = 2,
  headerRightClassName,
}) => {
  const {t} = useTranslation();
  return (
    <div
      className={styles.container}
      style={{width: customWidth, zIndex: zIndex}}
    >
      <div className={styles.header}>
        {title && <Title className={styles.title}>{title}</Title>}
        <div
          className={
            headerRightClassName
              ? concatStyles([styles.headerRight, headerRightClassName])
              : styles.headerRight
          }
        >
          {headerCustom && headerCustom()}
          {requestClose && (
            <h4 className={styles.closeButton} onClick={requestClose as any}>
              {t('common.close')}
            </h4>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default Modal;
